export default "__VITE_ASSET__BFlQN5Bl__"